const CommandComponent = {
  template: require('./commands.html'),
  restrict: 'E',
  bindings: {},
  controller: CommandController,
  controllerAs: 'vm'
};

function CommandController($stateParams, CommandHistoryService, CommandService, $q, $interval) {
  'ngInject';

  var vm = this;
  var interval;
  const INTERVAL_TIME = 300000;

  vm.equipmentId = null;
  vm.updateHistory = updateHistory;
  vm.updatingHistory = false;
  vm.history = [];
  vm.historyStatus = {};
  vm.commandGroups = [];
  vm.commandAlertStatus = [];
  vm.commandList = [];
  vm.loading = false;

  vm.$onInit = init;

  function init() {
    vm.equipmentId = $stateParams.equipmentId;
    getEquipmentCommands(vm.equipmentId).then(function() {
      getHistory(vm.equipmentId, vm.commandList);
    });
  }

  vm.$onDestroy = function() {
    $interval.cancel(interval);
  };

  function updateHistory() {
    return getHistory(vm.equipmentId, vm.commandList);
  }

  function getHistory(equipmentId, commands) {
    vm.updatingHistory = true;
    return CommandHistoryService.getHistory(vm.equipmentId, commands).then(function(history) {
      vm.history = history;
      vm.updatingHistory = false;
    });
  }

  function getEquipmentCommands(equipmentId) {
    vm.loading = true;
    let promises = [CommandService.packageCommandsConfig(equipmentId), CommandService.getEquipmentSeries(equipmentId)];

    return $q
      .all(promises)
      .then(function([commandConfig, equipmentSeries]) {
        vm.commandGroups = commandConfig.commandGroups;
        vm.commandAlertStatus = CommandService.getHealthStatus(equipmentSeries, commandConfig.controlsStatus);
        vm.commandList = commandConfig.commands;
        setStatusUpdateInterval();
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  function updateEquipmentCommandAlertStatus(equipmentId) {
    CommandService.getEquipmentSeries(equipmentId).then(function(series) {
      vm.commandAlertStatus = CommandService.getHealthStatus(series);
    });
  }

  function setStatusUpdateInterval() {
    interval = $interval(function() {
      updateEquipmentCommandAlertStatus(vm.equipmentId);
    }, INTERVAL_TIME);
  }
}

export default CommandComponent;
